import { NgModule } from '@angular/core';
import { ICmsCampaignsService } from './service/icms-campaigns-client.service';

@NgModule()
export class ICmsCampaignsClientModule {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor(iCmsCampaignsService: ICmsCampaignsService) {}
}
